import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

import { asyncConnect } from 'redux-connect';
import * as ProductActions from 'redux/modules/products';

import { ProductForm, ModeOpe } from 'components';

import { isLoaded as areGroupsLoaded, load as loadGroups } from 'redux/modules/groups';
import { isLoaded as areUsersLoaded, load as loadUsers } from 'redux/modules/users';

import _ from 'underscore';

require('./geosuggest.css');
import ReactModal from 'react-modal';

import { Button, Col } from 'react-bootstrap';
import { ErrorAlert } from 'components';

var modalStyles =
{
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.75)',
    zIndex: 1000000
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    //marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    //width											 : '700px',
    height: '400px'

  }
}
import { translate } from 'react-i18next';

@translate(['common'])
@asyncConnect([{
  promise: ({ store: { dispatch, getState }, params }) => {
    const promises = [];
    promises.push(dispatch(ProductActions.loadProduct(params.productID, params)));
    promises.push(dispatch(loadGroups(params)));
    promises.push(dispatch(loadUsers(params)));
    //promises.push(dispatch(ProductActions.sortCounts(null,null, params)));
    return Promise.all(promises);
  }
}])
@connect(
  state => ({
    product: state.products.product,
    groups: state.groups.data,
    error: state.products.error,
    users: state.users.data
  })
)
export default class EditProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.reloadPage = this.reloadPage.bind(this);
  }

  handleOpenModal() {
    this.setState({ showModal: true });
  }

  handleCloseModal() {
    this.setState({ showModal: false });
  }

  reloadPage() {
    var params = this.props.params;
    const promises = [];
    promises.push(this.props.dispatch(ProductActions.loadProduct(params.productID, params)));
    promises.push(this.props.dispatch(loadGroups(params)));
    promises.push(this.props.dispatch(loadUsers(params)));
    return Promise.all(promises);
  }

  render() {
    const {
      t, product, groups, params, error, users
    } = this.props;

    const styles = require('./AddProduct.scss');
    var objFiche = {};
    var groups_ids;

    try {
      groups_ids = product.groups.length > 0 ?
        product.groups.map((g) => {
          return { value: g.g_id, label: g.name };
        }) : []
    } catch (e) {
      groups_ids = []
    }

    var site = _.pick(product,
      's_id',
      'identification_URL',
      'identification_URL_ACTIVE',
      'identification_FOLDER',
      'identification_LOGIN',
      'identification_PASS',
      'identification_complement',
      'etat',
      'product_etat',
      'site_etat',
      'etat_en_service',
      'etat_en_panne',
      'etat_en_travaux',
      'etat_telesurveillance',
      'etat_supervision',
      'etat_telealarme',
      't_id',
      'etat_FTP'
    );

    site['id'] = site['s_id']

    delete site['s_id']

    var product2 = _.omit(product,
      'identification_URL',
      'identification_URL_ACTIVE',
      'identification_FOLDER',
      'identification_LOGIN',
      'identification_PASS',
      'identification_complement',
      'etat',
      'product_etat',
      'site_etat'
    )

    return (
      <div className={'container'}>
        <Helmet title={t("main.edit_sheet")}/>

        {error &&
          <ErrorAlert buttonText={t("dashboardView.reload_page")}
            callback={() => this.props.dispatch(ProductActions.loadProduct(params.productID, params))}
            errorMessage={error}
          />
        }

        {product &&


          <ProductForm action="update" urlParams={this.props.params}
            formKey={String(product2.id)} productId={String(product2.id)}
            key={String(product2.id)}
            site={site}
            initialValues={{ product: product2, groups: groups_ids, site, users: product.users.map((u) => { return { label: u.login, value: u.id } }) }}
            pristineValues={{ product: product2, groups: product2.groups, site, users: product.users }}
            phones={product2.phones}
            handleOpenModal={this.handleOpenModal}
            users={users}
            reloadPage={this.reloadPage}
          />
        }


        <Col xs={12} md={12}>

          {this.state.showModal &&
            <ReactModal
              isOpen={this.state.showModal}
              contentLabel="" style={modalStyles}
            >

              <div>
                <div style={{position:'sticky', top: 0, textAlign:'right', background:'white', padding:'5px 0', zIndex: 1}}>
                  <i onClick={this.handleCloseModal} className="fa fa-times-circle fa-2x" style={{color: '#888', cursor:'pointer'}}/>
                </div>
                <ModeOpe />
              </div>
            
            </ReactModal>
          }

        </Col>

      </div>
    );
  }
}
